<template>
  <a-modal
    v-model="visible"
    :width="modelWidth"
    :mask-closable="false"
    :footer="null"
    title="消息推送设置"
    :destroy-on-close="true"
    centered
    @cancel="onhidden"
  >
     <div class="message_push_content">
         <!-- <el-tree class="carrier_tree" :check-on-click-node="true"  :default-expand-all="true" :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
         <carrier-tree v-if="enterprise"  class="carrier_tree" :data="data" :default-carrier="defaultCarrier" @select="handleNodeClick"></carrier-tree>
        <div :loading="formLoading">
        <a-form-model ref="ruleForm" class="message_form" :model="form"  :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <template v-for="(item) in defaultData">
            <a-form-model-item  :key="item.pushTypeEnum" :label="title[item.pushTypeEnum]" class="my-item" >
              <a-switch checked-children="开" un-checked-children="关" :checked="filterChecked(ConfigList[item.pushTypeEnum].pushStatus)" @change="(checked)=>{switchChange(checked, item.pushTypeEnum)}" />
              <span v-if="item.pushTypeEnum===TYPE_ENUM.ORDER_REPORT"  class="tips"><a-icon type="exclamation-circle" class="icon" />报告完成通知在时间周期T+1 10:00统一发送</span>
              <span v-if="item.pushTypeEnum===TYPE_ENUM.BILL_GENERATION"  class="tips"><a-icon type="exclamation-circle" class="icon" />根据合同结算周期,生成账单后同步推送</span>
              <div v-if="item.pushTypeEnum ===TYPE_ENUM.ORDER_REPORT" class="form-config checkbox-bar">
                <label :class="{'defaultStyle':true,'closeStyle':!filterChecked(ConfigList[item.pushTypeEnum].pushStatus)}">推送周期</label>
                <el-checkbox-group
                v-model="ConfigList[item.pushTypeEnum].pushReportSet"
                class="message_radio"
                :min="1"
                > 
                 <el-checkbox
                  v-for="item1 in plainOptions"
                  :key="item1.value"
                  :disabled="!filterChecked(ConfigList[item.pushTypeEnum].pushStatus)"
                  :label="item1.value"
                 >
                  {{item1.label}}
                </el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-else-if="item.pushTypeEnum ===TYPE_ENUM.BILL_GENERATION"></div>
               <div v-else class="form-config">
                <label :class="{'defaultStyle':true,'closeStyle':!filterChecked(ConfigList[item.pushTypeEnum].pushStatus)}">推送时间</label>
                <el-radio-group v-model="ConfigList[item.pushTypeEnum].pushTimeEnum" class="message_radio">
                  <el-radio  
                  v-for="item1 in timeList"
                  :key="item1.value"
                  :disabled="!filterChecked(ConfigList[item.pushTypeEnum].pushStatus)"
                  :label="item1.value">
                  {{item1.label}}
                  </el-radio>
                </el-radio-group>
              </div>
            </a-form-model-item>
          </template>
          <a-form-model-item label="消息推送渠道" prop="pushChannelEnum"  >
            <el-checkbox v-model="form.pushChannelEnum" label="WE_CHAT" checked class="message_radio">
              微信
            </el-checkbox>
          </a-form-model-item>
        </a-form-model>
    <a-row class="btnBox">
      <a-col :span="8" :offset="16">
        <a-button @click="onhidden">取消</a-button>
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </a-col>
    </a-row>
      </div>
     </div>
  </a-modal>
</template>
<script>
import {getSignType} from '@/api/enterprise/authentication'
import { messagePush, getMessage } from '../api.js'
import CarrierTree from './CarrierTree.vue'

const pushChannelMap = {
  true:'WE_CHAT',
  false:''
}
const TYPE_ENUM={
  ORDER_STATUS:'ORDER_STATUS',
  ORDER_EX:'ORDER_EX',
  ORDER_REPORT:'ORDER_REPORT',
  BILL_GENERATION:'BILL_GENERATION'
}
const validatorData= (rule, value, callback)=>{
  if(!value){
    callback('请选择推送渠道')
  }
  callback()
};
export default ({
  name: 'MessagePush',
  components: {
    CarrierTree
  },
  data(){
    return {
      visible: false,
      labelCol: { span: 5 },
      TYPE_ENUM,
      defaultData:[
        {
          pushStatus: 'DISABLE',
          pushTimeEnum: '',
          pushTypeEnum: 'ORDER_STATUS'
        },
        {
          pushStatus: 'DISABLE',
          pushTimeEnum: '',
          pushTypeEnum: 'ORDER_EX'
        },
        {
          pushStatus: 'DISABLE',
          pushReportSet: [],
          pushTypeEnum: 'ORDER_REPORT',
        },
        {
          pushStatus: 'DISABLE',
          pushReportSet: [],
          pushTypeEnum: 'BILL_GENERATION',
        },
      ],
      wrapperCol: { span: 14 },
      plainOptions: [
        { label: '日报告', value: 'DAY_REPORT' },
        { label: '周报告', value: 'WEEK_REPORT' },
        { label: '月报告', value: 'MONTH_REPORT' },
      ],
      timeList: [
        {
          label: '每天上午 9:00',
          value: 'DAY_AT_9_AM'
        },
        {
          label: '每天下午 16:00',
          value: 'DAY_AT_18_PM'
        },
        {
          label: '每天早晚一次',
          value: 'MORNING_AND_EVENING'
        },
      ],
      title: {
        ORDER_STATUS: '订单状态通知',
        ORDER_EX: '订单异常消息',
        ORDER_REPORT: '报告生成通知',
        BILL_GENERATION:'账单生成通知'
      },
      ConfigList:{},
      form: {
        pushChannelEnum: 'WE_CHAT'
      },
      userId: '',
      isFill:true,
      rules:{
        pushChannelEnum:[
          { required: false,validator:validatorData, trigger: 'change' },
        ],
      },
       data:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        formLoading:false,
        defaultCarrier:'',
        modelWidth:"40%"
    }
  },
  created(){
    this.initDefaultData()
    this.enterprise=!!this.$store.state.user.creditCode
  },
  
  methods: {
   async getCarrier(){
       const {customers} =this.$store.state.user
        const params=customers.map(item=>item.customerId)
        const data={
          ids:params,
        }
       this.data= await getSignType(data)
      this.handleNodeClick(this.data[0])
    },
    handleNodeClick(data) {
        this.selectCarrier=data
        this.defaultCarrier=data.id
        this.initDefaultData()
        this.getMessage(data.customerCode )
      },
   initDefaultData(){
     this.ConfigList={
        ORDER_STATUS:{
            pushStatus: 'DISABLE',
            pushTimeEnum: '',
            pushTypeEnum: 'ORDER_STATUS'
          },
          ORDER_EX:{
            pushStatus: 'DISABLE',
            pushTimeEnum: '',
            pushTypeEnum: 'ORDER_EX'
          },
          ORDER_REPORT:{
            pushStatus: 'DISABLE',
            pushReportSet: [],
            pushTypeEnum: 'ORDER_REPORT',
          },
          BILL_GENERATION:{
            pushStatus: 'DISABLE',
            pushTypeEnum: 'BILL_GENERATION',
          }
     }
   },
    filterChecked(status){
      if(status === 'ENABLE'){
        return true
      } 
      return false
    },
   async show(userId){
      this.userId = userId
      this.initDefaultData()
      const {customerCode,creditCode}=this.$store.state.user
      if(!creditCode){
        this.getMessage(customerCode)
        this.modelWidth='40%'
      }else{
        await this.getCarrier()
        this.modelWidth='60%'
      }
      this.visible = true
    },
    async getMessage(customerCode){
      this.formLoading=true
      const res= await getMessage({customerCode,userId:this.userId})
       if(res.pushConfigList.length > 0){
            this.form={
              ...res,
              pushChannelEnum:true
            }
            res.pushConfigList.forEach(item=>{
              this.ConfigList[item.pushTypeEnum]=item
            })
            this.formLoading=false
          } else {
            this.formLoading=false
            this.visible = true
          }
    },
    switchChange(checked, item){
      if(checked){
        this.ConfigList[item].pushStatus = 'ENABLE'
        if(item === TYPE_ENUM.BILL_GENERATION){
          this.ConfigList[item].pushTimeEnum = ''
        }else if(item !== TYPE_ENUM.ORDER_REPORT){
          this.ConfigList[item].pushTimeEnum = 'DAY_AT_9_AM'
        } else {
          this.ConfigList[item].pushReportSet=['DAY_REPORT']
        }
      } else {
        this.ConfigList[item].pushStatus = 'DISABLE'
        if(item !== TYPE_ENUM.ORDER_REPORT){
          this.ConfigList[item].pushTimeEnum = ''
        }else {
          this.ConfigList[item].pushReportSet=[]
        }
      }
    },
    onhidden(){
      this.visible = false
    },
    onSubmit(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if(!this.isFill)return
         const form={
            pushConfigList:Object.values(this.ConfigList),
            pushChannelEnum:pushChannelMap[this.form.pushChannelEnum]
          }
          const {accountName,customerCode,creditCode}=this.$store.state.user
          if(creditCode){
            messagePush({
            ...form,
            customerCode:this.selectCarrier.customerCode,
            customerName:this.selectCarrier.customerName,
            userId: this.userId,
          }).then(() => {
            this.$message.success('提交成功')
            this.visible = false
          })
          }else{
            messagePush({
            ...form,
            customerCode,
            customerName:accountName,
            userId: this.userId,
          }).then(() => {
            this.$message.success('提交成功')
            this.visible = false
          })
          }
          
        } 
      });
      
    }
  }
})
</script>
<style lang="less" scoped>
.btnBox {
  text-align: right;
  button {
    margin-left: 15px;
  }
}
.my-item {
  margin-bottom: 20px;
  display: flex;
  .ant-form-item {
    margin-bottom: 0;
  }
 /deep/ .ant-form-item-control-wrapper {
    flex: 1;
  }
  .tips {
    color: #909399;
    margin-left: 14px;
    font-size: 12px;
    .icon {
      margin-right: 4px;
    }
  }
}
.defaultStyle {
  margin-right: 20px;
  font-size: 14px;
}
.closeStyle {
  color: #C9CBCE;
}
::v-deep.message_radio {
  .el-radio__input.is-checked .el-radio__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #06b880;
    border-color: #06b880;
  }
  .el-radio__inner:hover,
  .el-checkbox__inner:hover,
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #06b880;
  }
  .el-radio__input.is-checked+.el-radio__label,
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #06b880;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  .el-radio {
    margin-right: 20px;
  }
}
.checkbox-bar {
  display: flex;
  /deep/.el-checkbox {
    margin-right: 62px;
  }
}
.checkbox_content {
  display: flex;
  flex-direction: column;
  position: relative;
}
.errorFill {
  color: #f5222f;
  position: absolute;
  bottom: -22px;
  font-size: 14px;
}
.message_push_content {
  display: flex;
  .carrier_tree {
    width: 300px;
    border-right: 1px solid #ccc;
    margin-right: 40px;
  }
  .message_form {
    width: 600px;
  }
}
</style>
